// PixiJS v8 async Application bootstrap. autoStart:false so we own rendering
// (render-on-demand, GDD §13.4) via a standalone Ticker in main.ts.

import { Application } from 'pixi.js';

export const OCEAN_COLOR = 0x3f82b0; // deep sea blue (shallow-water halos read against it)

export async function createApp(mount: HTMLElement): Promise<Application> {
  const app = new Application();
  await app.init({
    resizeTo: window,
    background: OCEAN_COLOR,
    antialias: true,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
    autoStart: false,
    preference: 'webgl',
  });
  mount.appendChild(app.canvas);
  return app;
}
